import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

/**
 * Shared Loader component for displaying loading states
 * Can be used for lazy loading routes, async operations, etc.
 */
const Loader = ({
    fullScreen = true,
    size = '50px',
    strokeWidth = '4',
    message = null
}) => {
    const containerClasses = fullScreen
        ? 'flex justify-center items-center h-screen bg-gray-50'
        : 'flex justify-center items-center p-8';

    return (
        <div className={containerClasses}>
            <div className="flex flex-col items-center gap-4">
                <ProgressSpinner
                    style={{ width: size, height: size }}
                    strokeWidth={strokeWidth}
                    animationDuration=".5s"
                />
                {message && (
                    <p className="text-gray-600 text-sm font-medium animate-pulse">
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Loader;
